export default __webpack_public_path__ + "assets/images/fc02119e593c5577f1c282f071a6c3cc.png";